import { FC } from "react";
import { MuiButtonPrimary, MuiButtonSecondary } from "../../../../components";
import PermissionWrapper from "../../../../components/permissionWrapper/PermissionWrapper";
import { MODULE_PERMISSIONS } from "../../../../helpers/constants";
import { COMPONENT_IDS } from "../../../../helpers/constants/componentIds";
import { useSiteCore } from "../../../../hooks/useSiteCore";
import { CPViewParticipantFooterWrapper } from "./CPViewParticipantFooter.style";

interface CPViewParticipantFooterProps {
  pageId: string;
  handleNavigateBack: () => void;
  handleEdit?: () => void;
  showEditButton?: boolean;
}

export const CPViewParticipantFooter: FC<CPViewParticipantFooterProps> = ({
  pageId,
  handleNavigateBack,
  handleEdit,
  showEditButton = true,
}) => {
  const { commonLabels } = useSiteCore();

  const onCloseButton = () => {
    handleNavigateBack();
  };

  return (
    <CPViewParticipantFooterWrapper>
      <MuiButtonSecondary
        data-testid={COMPONENT_IDS.CLOSE_BUTTON}
        id={`${pageId}-close`}
        onClick={onCloseButton}
      >
        {commonLabels.close}
      </MuiButtonSecondary>
      {showEditButton && (
        <PermissionWrapper permission={MODULE_PERMISSIONS.COACH_PORTAL_EDIT}>
          <MuiButtonPrimary
            data-testid={COMPONENT_IDS.EDIT_BUTTON}
            onClick={handleEdit}
            id={`${pageId}-edit`}
          >
            {commonLabels.edit}
          </MuiButtonPrimary>
        </PermissionWrapper>
      )}
    </CPViewParticipantFooterWrapper>
  );
};
